import React from "react";

function InformacoesGerais() {
  return (
    <div className="w-full mb-[50px] sm:mb-0 flex flex-col items-center">
      <p className="text-[9px] font-light text-[#696766]">
        Instituto Selma Cosso
      </p>
      <p className="text-[9px] font-light text-[#696766]">
        Versão: 1.0.0 (Alfa)
      </p>
    </div>
  );
}

export default InformacoesGerais;
